import { HStack, Text, Icon, Box, useDisclosure, VStack, StackDivider } from '@chakra-ui/react';

import { IoCheckmarkSharp, IoChevronDown, IoChevronUp } from 'react-icons/io5';

import * as fp from 'lodash/fp';

type CategoriesMenuProps = {
  activeCategory: { id: string; name: string };
  categoriesList: Array<{ id: string; name: string }>;
  onChangeCategory: (value: { id: string; name: string }) => void;
};

// 類別選項列表 可導向特定類別
export default function CategoriesMenu({
  activeCategory,
  categoriesList,
  onChangeCategory,
}: CategoriesMenuProps) {
  const { isOpen, onToggle, onClose } = useDisclosure();

  return (
    <Box bgColor="white" borderBottomWidth="2px" borderColor="primary">
      <HStack
        cursor="pointer"
        justify="space-between"
        px={4}
        py={2}
        align="center"
        onClick={onToggle}
      >
        <Text>{activeCategory.name}</Text>
        <Icon as={isOpen ? IoChevronUp : IoChevronDown} boxSize="1.2rem" color="primary" />
      </HStack>
      {isOpen ? (
        <VStack align="stretch" divider={<StackDivider />} spacing={0}>
          {categoriesList.map((category) => {
            const isActive = fp.eq(category.id, activeCategory.id);
            return (
              <HStack
                key={category.id}
                as="button"
                cursor="pointer"
                align="center"
                py={2}
                px={4}
                bgColor={isActive ? 'primary' : 'white'}
                onClick={() => {
                  onChangeCategory(category);
                  onClose();
                }}
              >
                <Icon
                  as={IoCheckmarkSharp}
                  color={isActive ? 'white' : 'transparent'}
                  boxSize="1.2rem"
                />
                <Text color={isActive ? 'white' : 'fontColor'}>{category.name}</Text>
              </HStack>
            );
          })}
        </VStack>
      ) : null}
    </Box>
  );
}
